<template>
  <b-dropdown variant="primary" menu-class="small-dropdown a-dropdown-menu">
    <template slot="button-content" style="width: 200px">
      <i class="far fa-filter mr-2" v-if="!value"></i>
      <span class="mr-auto">{{value || 'Filter Results'}}</span>
      <i class="far fa-angle-down ml-2"></i>
    </template>
    <div class="dropdown-header">
      <h6>{{menuTitle}}</h6>
      <b-link @click="status = undefined" :disabled="status === undefined">
        <span>Clear</span>
      </b-link>
    </div>
    <b-dropdown-item
      @click="status = option"
      v-for="option in options"
      :key="option"
      :active="status === option"
    >
      <span>{{option}}</span>
    </b-dropdown-item>
  </b-dropdown>
</template>

<script>
export default {
  props: {
    value: String,
    options: Array,
    menuTitle: {
      type: String,
      required: true
    }
  },
  computed: {
    status: {
      set(newVal) {
        this.$emit("input", newVal);
      },
      get() {
        return this.value;
      }
    }
  }
};
</script>

<style lang="scss">
.dropdown-toggle.btn-primary {
  background-color: white;
  border: 1px solid #d2ddec;
  color: #12263F;
  width: 200px;
  display: flex;
  align-items: center;
}
</style>

